webpackJsonp([223774567886634],{

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(39);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _user = __webpack_require__(813);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  card: {
	    display: 'flex',
	    minWidth: '50%',
	    margin: [35, 0]
	  },
	  bigCard: {
	    display: 'flex',
	    minWidth: '100%'
	  },
	  img: {
	    width: 86,
	    height: 86,
	    marginRight: 15
	  },
	  bigImg: {
	    width: 170,
	    height: 179,
	    marginRight: 35
	  },
	  name: {
	    textTransform: 'uppercase',
	    fontWeight: 'bold',
	    fontSize: 20
	  },
	  title: {
	    color: 'rgb(237, 9, 37)',
	    fontSize: '0.8em'
	  },
	  phone: {
	    marginTop: '0.7em',
	    fontSize: '0.8em'
	  },
	  email: {
	    fontSize: '0.8em'
	  }
	
	};
	
	var ContactCard = (0, _reactJss2.default)(styles)(function (_ref) {
	  var classes = _ref.classes,
	      isBig = _ref.isBig,
	      name = _ref.name,
	      title = _ref.title,
	      phone = _ref.phone,
	      email = _ref.email;
	  return _react2.default.createElement(
	    'div',
	    { className: classes[isBig ? 'bigCard' : 'card'] },
	    _react2.default.createElement('img', { src: _user2.default, className: classes[isBig ? 'bigImg' : 'img'] }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.data },
	      _react2.default.createElement(
	        'div',
	        { className: classes.name },
	        name
	      ),
	      title && _react2.default.createElement(
	        'div',
	        { className: classes.title },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.phone },
	        'Puhelin: ',
	        _react2.default.createElement(
	          'a',
	          { href: 'tel: ' + phone },
	          phone
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.email },
	        'S\xE4hk\xF6posti: ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto: ' + email },
	          email
	        )
	      )
	    )
	  );
	});
	
	exports.default = ContactCard;
	module.exports = exports['default'];

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ContactCard = __webpack_require__(318);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContactCard).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ContactCard = __webpack_require__(319);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	var _PageLayout = __webpack_require__(21);
	
	var _PageLayout2 = _interopRequireDefault(_PageLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOIMIHENKILOT = function TOIMIHENKILOT() {
	  return _react2.default.createElement(
	    _PageLayout2.default,
	    { pageTitle: 'TOIMIHENKIL\xD6T' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'TOIMIHENKIL\xD6T'
	      // meta={[
	      //   { name: 'description', content: 'Sample' },
	      //   { name: 'keywords', content: 'sample, something' },
	      // ]}
	    }),
	    _react2.default.createElement(
	      'h2',
	      { style: { textAlign: 'center' } },
	      'SUKUYHDISTYKSEN HALLITUS 2018-2020'
	    ),
	    _react2.default.createElement(_ContactCard2.default, {
	      isBig: true,
	      name: 'KRISTIINA MATTILA-NOUSIAINEN (Ka)',
	      title: 'Puheenjohtaja',
	      phone: '0400- 458 749',
	      email: 'kristiina.mattilaph@gmail.com'
	    }),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'J\xC4SENET'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flexRow' },
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'ISMO PELTONEN (Ka)',
	        title: 'Sihteeri, j\xE4senposti',
	        phone: '0400-899 743',
	        email: 'ismo.peltonen@dnainternet.net'
	      }),
	      _react2.default.createElement(_ContactCard2.default, { name: 'P\xC4IVI JUUTILAINEN (Ka)' }),
	      _react2.default.createElement(_ContactCard2.default, { name: 'JOUKO LEINONEN (Ka)' }),
	      _react2.default.createElement(_ContactCard2.default, { name: 'MAIRE KALLIOKOSKI (Mi/Ka/Er)' }),
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'RAINO MARTTUNEN (Ka)',
	        phone: '050-541 8140',
	        email: 'raino.marttunen@eduskunta.fi'
	      }),
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'ARI OJANEN (Er)',
	        phone: '050-301 7484',
	        email: 'ari.ojanen@elisanet.fi'
	      }),
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'PIRJO PUNAKALLIO (Ka)',
	        phone: '040-530 5885',
	        email: 'pirjo.punakallio@welho.com'
	      }),
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'MIKKO RUOPPI (Mi)',
	        phone: '040-520 9971',
	        email: 'mikko.ruoppi@phnet.fi'
	      }),
	      _react2.default.createElement(_ContactCard2.default, { name: 'PETRI SIPIL\xC4 (Ka)' }),
	      _react2.default.createElement(_ContactCard2.default, {
	        name: 'TARJA WARPENIUS (Ka)',
	        phone: '040-502 7590',
	        email: 'tarja@warpenius.fi'
	      })
	    )
	  );
	};
	
	exports.default = TOIMIHENKILOT;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-toimihenkilot-js-b670c3baa77a7066abfa.js